import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import useTranslate from "../../../hooks/useTranslate";
import { replaceValuesInText } from "../../../utils/replaceValuesInText";
import { currentCurrency } from "../../../redux/user/selectors";
import "./styles.sass";

interface LoyaltyMoreRewardCardProps {
  variant: string;
  value: string;
  image?: string;
  imageStatic?: string;
  freeSpinsGame?: string | undefined;
  isRow?: boolean;
  className?: string;
}

export const LoyaltyMoreRewardCard = ({
  imageStatic,
  image,
  value,
  variant,
  freeSpinsGame,
  isRow,
  className,
}: LoyaltyMoreRewardCardProps) => {
  const t = useTranslate();
  const currencyCode = useSelector(currentCurrency);

  let titleKey = "";
  let descKey = "";
  switch (variant) {
    case "nominal":
      titleKey = replaceValuesInText(
        t("loyalty.redesign.1.card.next-rank.nominal.title"),
        {
          value: `+${value} ${currencyCode}`,
        },
      );
      descKey = t("loyalty.redesign.1.card.next-rank.nominal.description");
      break;
    case "free_spins":
      titleKey = replaceValuesInText(
        t("loyalty.redesign.1.card.next-rank.freespins.title"),
        {
          value,
        },
      );
      descKey = replaceValuesInText(
        t("loyalty.redesign.1.card.next-rank.freespins.description"),
        {
          gamename: freeSpinsGame || "",
        },
      );
      break;
    case "mascot":
      titleKey = t("loyalty.redesign.1.card.next-rank.mascot.title");
      descKey = t("loyalty.redesign.1.card.next-rank.mascot.description");
      break;
    case "cashbackDaily":
      titleKey = replaceValuesInText(
        t("loyalty.redesign.1.cashback-daily.title"),
        {
          value,
        },
      );
      descKey = t("loyalty.redesign.1.cashback-daily.subtitle");
      break;
    case "cashbackWeekly":
      titleKey = replaceValuesInText(
        t("loyalty.redesign.1.cashback-weekly.title"),
        {
          value,
        },
      );
      descKey = t("loyalty.redesign.1.cashback-weekly.subtitle");
      break;
    case "cashbackMonthly":
      titleKey = replaceValuesInText(
        t("loyalty.redesign.1.cashback-monthly.title"),
        {
          value,
        },
      );
      descKey = t("loyalty.redesign.1.cashback-monthly.subtitle");
      break;
    default:
      titleKey = "";
      descKey = "";
  }

  return (
    <div
      className={classNames(
        "LoyaltyMoreRewardCard",
        isRow && "LoyaltyMoreRewardCard_isRow",
        className,
      )}
    >
      <img
        src={imageStatic || image}
        alt="card"
        className="LoyaltyMoreRewardCard__img"
      />
      <section className="LoyaltyMoreRewardCard-content">
        <span className="LoyaltyMoreRewardCard-content__title">{titleKey}</span>
        <span className="LoyaltyMoreRewardCard-content__desc">{descKey}</span>
      </section>
    </div>
  );
};
